<template>
    <form @submit="submit" class="item-editor-form">
        <fg-input v-model="item.name" :label="$t('vehicle_groups.name')"></fg-input>
        <label for="organization">{{ $t('vehicle_groups.organization') }}:</label>
        <organisationSelect v-model="item.organization" id="organization"/>

        <FormButtons
            @submit="submit"
            :submit="$UIPrivilegeUpdate('realtime', 'vehiclegroups')"  
            :reset="false" 
            :remove="action == 'edit' && $UIPrivilegeDelete('realtime', 'vehiclegroups')" 
            @remove="remove"
            :itemid="item.name"
            :modalid="'vehicleGroupEditModal'"
            :disableSubmit="loading"
            :disableRemove="loading "/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
</template>

<script>
import vehicleGroup from '@/store/realtime/vehicleGroup';
import FormButtons from '@/components/Misc/FormButtons';
import organisationSelect from '@/components/Timetable/OrganisationSelect';

export default {
    components: {
        FormButtons, organisationSelect
    },
    props: {
        item: {        
            default: function () {
                return {
                    id: null
                };
            }
        },
        action: { default: 'new' }
    },
    data: function() {
        return  {
            ok: false,
            error: false,
            loading: false,
            infoType: 'save'
        }
    },
    beforeCreate() {
        if (!this.$store.state.vehicleGroup) {
            this.$store.registerModule('vehicleGroup', vehicleGroup);
        }
    },
    methods: {
        submit(event) {
            if (event)
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = 'save';
            this.loading = true;

            setTimeout(() => {
                this.$store.dispatch('vehicleGroup/saveVehicleGroup', this.item).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        },
        remove() {
            this.infoType = 'delete';
            this.loading = true;

            setTimeout(() => {
                this.$store.dispatch('vehicleGroup/deleteVehicleGroup', this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        }
    }
}
</script>
